const PRODUCTION_ORIGIN = 'https://qa.replay.io'

/** User-session capture is intentionally limited to the canonical production site. */
export function isSessionMonitoringOrigin(origin: string): boolean {
  return origin === PRODUCTION_ORIGIN
}
